import { Col, Row, Tabs, Typography } from "antd";


import SecureTypeInfoes from "./Components/SecureTypeInfoes";
import { useGetPageDetailsByPageType } from "apps/FAQ/ServerSideStates";
import { useEffect, useState } from "react";
import StaticPageBanner from "apps/Common/StaticPageBanner";
import { Helmet } from "react-helmet-async";

const SecureShopping = () => {
  const { Text } = Typography;
  const pageDetails = useGetPageDetailsByPageType(2);
  const [groupDataList, setGroupDataList] = useState([]);
  const [items, setItems] = useState<any[]>([]);

  useEffect(() => {
    if (pageDetails?.data?.data?.pageItem) {
      const data = pageDetails?.data?.data?.pageItem;

      const titles = data.filter((item: any) => item.isTitle === true);

      const groupedData = titles.map((title: any) => ({
        name: title.name, // Ana başlık
        subTopics: data.filter(
          (item: any) =>
            item.isTitle === false && item.groupId === title.groupId
        ),
      }));

      setItems(
        groupedData?.map((item: any, index: number) => {
          return {
            key: index,
            label: item.name,
            children: <SecureTypeInfoes data={item.subTopics} />,
          };
        })
      );
      setGroupDataList(groupedData);
    }
  }, [pageDetails?.data?.data]);

  return (
    <>

      <Col xs={24} className="!overflow-hidden" >
        <Row gutter={[20, 20]}>
          <Col xs={24}>
            <StaticPageBanner
              title={pageDetails?.data?.data?.name || ""}
              description={pageDetails?.data?.data?.shortDescription || ""}
            />
            <Helmet>
              <title className="capitalize">{"Güvenli Alışveriş"}</title>
            </Helmet>
          </Col>
          <Col xs={24} className="">
            <div className="relative z-10 !px-2 lg:!px-6 xxl:!px-16 ">
              <Text className="text-base">{pageDetails?.data?.data?.shortDescription || ""}</Text>
            </div>
            <div className="!px-2 lg:!px-6 xxl:!px-16">
              <Tabs defaultActiveKey="1" items={items} />
            </div>
          </Col>
        </Row>
      </Col>


    </>
  );
};

export default SecureShopping;
